import { Component } from 'react';
import ScriptTag from 'react-script-tag';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import withRouter from '../../../hoc/withRouter';
import Can from '../../common/guards/can';
import RedirectToLogin from '../../common/redirect-to-login';
import Footer from '../../footer/user-footer';
import MainPopups from './main-popups';
import { footerLinksForUserLayout, footerLinksForPreloginUserLayout } from '../../../data/footerLinks';
import { check as loggedIn, currentUserGroup, isPseudoLoggedIn } from '../../../utils/tokenUtils';
import { isRepLoggedIn } from '../../../utils/sessionAreas';
import UserNavigation from '../user-navigation/user-navigation';
import { USER_TYPE_PRE_LOGIN, USER_TYPE_RETAILER } from '../../../data/userTypes';
import { getPpcManagementUrl } from '../../../actions/ppc';

import '../../sidenav/sidenav.css';
import './main-layout.css';
import CookieConsent from '../../cookie-consent/cookie-consent';

class PseudoLoginIndicator extends Component {
  componentDidMount() {
    const mode = this.props.active ? 'demo_mode' : 'standard_mode';

    TagManager.dataLayer({
      dataLayer: {
        viewMode: mode
      }
    });
  }

  render() {
    if (!this.props.active) return null;

    return (
      <div className="pseudo-login-indicator">
        Pseudo login active
      </div>
    );
  }
}

class MainLayout extends Component {
  componentDidMount() {
    this.props.dispatch(getPpcManagementUrl());
  }

  waitForElementToDisplay = (selector, callback, checkFrequencyInMs, timeoutInMs) => {
    const startTimeInMs = Date.now();

    (function loopSearch() {
      if (document.querySelector(selector) != null) {
        callback();
      } else {
        setTimeout(() => {
          if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) {
            return;
          }
          loopSearch();
        }, checkFrequencyInMs);
      }
    }());
  }

  gold = path => this.props.hasGoldTheme && !path.includes('privacy-policy');

  setScrolling() {
    return this.props.viewConfig.lockSroll ? 'noscroll' : '';
  }

  selectUserFrontendClassName() {
    const { path, hasSelectTheme } = this.props;
    const frontendClass = 'user-frontend';

    if (this.gold(path)) {
      return `${frontendClass}-gold`;
    }

    if (hasSelectTheme) {
      return `${frontendClass}-select`;
    }

    return frontendClass;
  }

  render() {
    if (currentUserGroup() === 'savi_auditor') {
      return <Navigate to="/admin" replace/>;
    }

    if (isRepLoggedIn()) {
      return <Navigate to="/team" replace/>;
    }

    const {
      component: RenderComponent,
      action,
      subjectClass,
      private: privateRoute,
      hidePseudo,
      isPseudoLogin,
      hasGoldTheme,
      path,
      match,
      location,
      history
    } = this.props;
    const matchProps = { match, location, history };
    const userFrontendClassName = this.selectUserFrontendClassName();
    let frontendContainerClassName = 'frontend-container';

    if ((hasGoldTheme) && path === '/') {
      frontendContainerClassName += ' user-frontend-background';
    }

    if (hidePseudo && isPseudoLogin) {
      return <Navigate to="/" replace/>;
    }

    if (!loggedIn()) {
      if (path === '/' || !privateRoute) {
        return (
          <div className={userFrontendClassName}>
            <div className={this.setScrolling.bind(this)}>
              <div className="frontend-container">
                <CookieConsent/>
                <RenderComponent {...matchProps} area={USER_TYPE_PRE_LOGIN}/>
                <Footer links={footerLinksForPreloginUserLayout}/>
              </div>
            </div>
          </div>
        );
      }

      return <RedirectToLogin requestedPath={window.location.pathname}/>;
    }

    return (
      <div className={userFrontendClassName}>
        <ScriptTag type="text/javascript" src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"/>
        <ScriptTag>{
          this.waitForElementToDisplay('.goog-te-gadget', () => {
            const googTeGadget = document.getElementsByClassName('goog-te-gadget')[0];
            const poweredByText = googTeGadget.getElementsByTagName('div')[0].nextSibling;
            const span = googTeGadget.getElementsByTagName('span')[0];

            if (typeof poweredByText.data === 'string') {
              span.prepend(poweredByText);
            }
          }, 125, 9000)
        }
        </ScriptTag>
        <Can action={action} cannot={<Navigate to="/my-profile" replace/>} subjectClass={subjectClass}>
          <div className={this.setScrolling.bind(this)}>
            <div className={frontendContainerClassName}>
              <PseudoLoginIndicator active={isPseudoLogin}/>
              <UserNavigation gold={ this.gold(path) }/>
              <RenderComponent {...matchProps} area={USER_TYPE_RETAILER}/>
              <Footer links={footerLinksForUserLayout}/>
            </div>
          </div>
        </Can>
        <MainPopups/>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.viewConfig.profile,
  viewConfig: state.viewConfig,
  isPseudoLogin: isPseudoLoggedIn(),
  hasRewardOutlet: state.viewConfig.profile.attributes['has-reward-outlet'],
  currentUser: state.currentUser.user,
  userLoading: state.currentUser.fetching,
  hasGoldTheme: state.viewConfig.profile.attributes['has-ignite-gold-outlet'],
  hasSelectTheme: state.viewConfig.profile.attributes['has-mini-chain-outlet']
});

export default withRouter(connect(mapStateToProps)(MainLayout));
